<template lang="pug">
UiSidebar.app-sidebar
  template(#header)
    RouterLink.logotype.solid-light(:to="{ name: 'Root' }")
  UiSidebarNavItem(
    v-for="item in navItems"
    :key="item.id"
    :to="item.url"
    :icon="item.icon"
    :active="isActive(item)"
  ) {{ item.label }}
</template>

<script>
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

const navItems = [
  {
    id: "companies",
    url: "/companies",
    label: "menu.companies",
    icon: "Buildings",
    allowedRoles: ["super_admin", "reseller", "user"],
  },
  {
    id: "resellers",
    url: "/resellers",
    label: "menu.resellers",
    icon: "Case",
    allowedRoles: ["super_admin"],
  },
  {
    id: "billing",
    url: "/billing",
    label: "menu.billing",
    icon: "Inbox",
    allowedRoles: ["super_admin", "reseller"],
  },
  {
    id: "super_admins",
    url: "/super_admins",
    label: "menu.super_admins",
    icon: "ContactBook",
    allowedRoles: ["super_admin"],
  },
  {
    id: "automation",
    url: "/automation",
    label: "menu.automation",
    icon: "Transfer",
    allowedRoles: ["super_admin", "reseller"],
  },
  {
    id: "admin_tools",
    url: "/admin_tools",
    label: "menu.admin_tools",
    icon: "Unlock",
    allowedRoles: ["super_admin"],
  },
  {
    id: "admin_users",
    url: "/admin_users",
    label: "menu.users",
    icon: "TwoUsers",
    allowedRoles: ["super_admin"],
  },
];

export default defineComponent({
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),

    navItems() {
      return navItems
        .map((item) => ({
          ...item,
          label: this.$t(item.label),
        }))
        .filter((item) => {
          return (
            item.allowedRoles.includes(this.user.role) &&
            !(this.user.role === "user" && this.user?.companies?.length === 0)
          );
        });
    },
  },
  methods: {
    /**
     * Forces the 'active' prop to true for nested/child routes (e.g., matching
     * '/companies' item when on '/companies/123').
     * NOTE: Exact path matching is handled automatically
     * by the underlying UiSidebarNavItem.
     */
    isActive(routeItem) {
      const currentPath = this.$route.path;
      const itemPath = routeItem.url;

      return currentPath.startsWith(`${itemPath}/`);
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheet/_variables.scss";
@import "@/assets/stylesheet/_mixins.scss";

.app-sidebar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;

  @include gradient-directional($bb-deep-green, $bb-grass-green, 135deg);

  & .logotype {
    width: 180px;
  }
}
</style>
